"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let PrinterTester = class PrinterTester extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    reloadJobAction(...args) {
        const [job] = args;
        job.busy = true;
        return this.$fn
            .fetch('print_job', { parameters: { printer: this.printerId, id: job.id } })
            .then(data => {
            console.log(data);
            _.extend(job, data);
            job.busy = false;
        });
    }
    printerId;
    onPrinter_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("printerId");
    }
    selectedFile;
    jobs;
    ux;
    dataMembers = ['selectedFile', 'jobs', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedFile: null,
                jobs: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_showModal_5136_getActionArgs($event) {
        return {
            name: "DataViewerModal",
            props: {
                mode: "yaml",
                content: $event.data.response.data,
            },
        };
    }
    async act_8564662037462133_request_5134_getActionArgs($event) {
        return {
            operation: "printer_attributes",
            data: {
                printer: this.printerId,
            },
        };
    }
    async evh_8564662037462133_clickPrevent(event, scope) {
        return await this.actions.evh_8564662037462133_clickPrevent.executeFromDOM(this, event, scope);
    }
    async act_4186377094414664_setData_5140_getActionArgs($event) {
        return {
            path: "jobs",
            value: $event.data.response.data.jobs,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4186377094414664_request_5138_getActionArgs($event) {
        return {
            method: "POST",
            operation: "print_document",
            data: {
                printer: this.printerId,
                document: this.selectedFile,
            },
            contentType: "multipart/form-data",
        };
    }
    async evh_4186377094414664_click(event, scope) {
        return await this.actions.evh_4186377094414664_click.executeFromDOM(this, event, scope);
    }
    async act_4747808328624104_script_5142_getActionArgs_value($event) {
        this.reloadJobAction($event.scope.item);
    }
    async act_4747808328624104_script_5142_getActionArgs($event) {
        return {
            value: () => this.act_4747808328624104_script_5142_getActionArgs_value($event),
        };
    }
    async evh_4747808328624104_click(event, scope) {
        return await this.actions.evh_4747808328624104_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_5132 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_5131 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_5132,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_5131],
        });
        const act_8564662037462133_showModal_5136 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8564662037462133_showModal_5136_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_success_5135 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_showModal_5136,
            event: "success",
            displayName: "showModal",
        });
        const act_8564662037462133_request_5134 = new core_1.actions.RequestAction({
            actionArgs: this.act_8564662037462133_request_5134_getActionArgs,
            displayName: "getAttributes",
            events: [evh_8564662037462133_success_5135],
        });
        const evh_8564662037462133_clickPrevent_5133 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_request_5134,
            event: "click.prevent",
            displayName: "getAttributes",
        });
        const evh_8564662037462133_clickPrevent = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_clickPrevent_5133],
        });
        const act_4186377094414664_setData_5140 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4186377094414664_setData_5140_getActionArgs,
            events: [],
        });
        const evh_4186377094414664_success_5139 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_setData_5140,
            event: "success",
            displayName: "setData",
        });
        const act_4186377094414664_request_5138 = new core_1.actions.RequestAction({
            actionArgs: this.act_4186377094414664_request_5138_getActionArgs,
            displayName: "printFile",
            events: [evh_4186377094414664_success_5139],
        });
        const evh_4186377094414664_click_5137 = new core_1.actions.EventHandlerImpl({
            action: act_4186377094414664_request_5138,
            event: "click",
            displayName: "printFile",
        });
        const evh_4186377094414664_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4186377094414664_click_5137],
        });
        const act_4747808328624104_script_5142 = new core_1.actions.ScriptAction({
            actionArgs: this.act_4747808328624104_script_5142_getActionArgs,
            events: [],
        });
        const evh_4747808328624104_click_5141 = new core_1.actions.EventHandlerImpl({
            action: act_4747808328624104_script_5142,
            event: "click",
            displayName: "script",
        });
        const evh_4747808328624104_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4747808328624104_click_5141],
        });
        return {
            act_7315092382398562_reloadComponentData_5132,
            evh_7315092382398562_reload_5131,
            evh_7315092382398562_reload,
            act_8564662037462133_showModal_5136,
            evh_8564662037462133_success_5135,
            act_8564662037462133_request_5134,
            evh_8564662037462133_clickPrevent_5133,
            evh_8564662037462133_clickPrevent,
            act_4186377094414664_setData_5140,
            evh_4186377094414664_success_5139,
            act_4186377094414664_request_5138,
            evh_4186377094414664_click_5137,
            evh_4186377094414664_click,
            act_4747808328624104_script_5142,
            evh_4747808328624104_click_5141,
            evh_4747808328624104_click,
            getAttributes: act_8564662037462133_request_5134,
            printFile: act_4186377094414664_request_5138,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], PrinterTester.prototype, "printerId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('printerId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], PrinterTester.prototype, "onPrinter_id", null);
PrinterTester = __decorate([
    (0, vue_property_decorator_1.Component)()
], PrinterTester);
exports.default = PrinterTester;
vue_property_decorator_1.Vue.component("PrinterTester", PrinterTester);
